var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slovakia",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 15,
    cy: 15,
    rx: 15,
    ry: 15,
    transform: "translate(-0.001 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M15,187.174a15.008,15.008,0,0,0,14.067-20.217H.933A15.008,15.008,0,0,0,15,187.174Z",
    transform: "translate(-0.001 -157.174)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M29.99,354.826a15.005,15.005,0,0,0,14.067-9.783H15.923A15.005,15.005,0,0,0,29.99,354.826Z",
    transform: "translate(-14.991 -324.825)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M66.2,144.7v7.483c0,4.256,5.561,5.561,5.561,5.561s5.561-1.3,5.561-5.561V144.7Z",
    transform: "translate(-62.32 -136.217)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M88.459,144.7v7.483a3.138,3.138,0,0,0,.331,1.414h7.851a3.138,3.138,0,0,0,.331-1.414V144.7Z",
    transform: "translate(-83.277 -136.217)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M121.794,170.87h-1.956v-1.3h1.3v-1.3h-1.3v-1.3h-1.3v1.3h-1.3v1.3h1.3v1.3h-1.957v1.3h1.957v1.3h1.3v-1.3h1.956Z",
    transform: "translate(-109.747 -157.174)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M95.887,270.675a9.372,9.372,0,0,0,2.146.971,9.369,9.369,0,0,0,2.146-.971,4.689,4.689,0,0,0,1.779-1.821,2.279,2.279,0,0,0-1.836-.359,2.283,2.283,0,0,0-4.179,0,2.279,2.279,0,0,0-1.836.359A4.688,4.688,0,0,0,95.887,270.675Z",
    transform: "translate(-88.595 -251.478)",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.b008b425b6df51dd4e4a83ad50e60918.svg";
export { ForwardRef as ReactComponent };